import {
  DisabledReason,
  GENERAL_OPERATIONS,
  PERM_MOD_CRM,
} from 'src/constants';
import { useAppSelector } from 'src/hooks/useStore';
import { useGetDisabledPermissionsQuery } from 'src/services/api/permissionsApi';
import { hasOperation } from 'src/utils/UserUtils';

export const useCreateClientPermission = () => {
  const { data: disabledPermissions } = useGetDisabledPermissionsQuery();
  const permissions = useAppSelector((state) => state.user.data?.permissions);
  const hasCreatePermission = hasOperation(
    PERM_MOD_CRM,
    GENERAL_OPERATIONS.CREATE,
    permissions,
  );

  const isCreateDisabledByPlanLimit = Boolean(
    disabledPermissions?.some(
      ({ permissionName, operationName, disabledReason }) => {
        return (
          permissionName === PERM_MOD_CRM &&
          operationName === GENERAL_OPERATIONS.CREATE &&
          disabledReason === DisabledReason.LimitReached
        );
      },
    ),
  );

  const disabledReason =
    permissions === undefined
      ? undefined
      : !hasCreatePermission
        ? DisabledReason.PermissionDenied
        : isCreateDisabledByPlanLimit
          ? DisabledReason.LimitReached
          : undefined;

  return {
    canCreateClient: !disabledReason,
    disabledReason,
  };
};
